import { createContext, useCallback, useMemo, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const MediaPlaybackRateContext = /*#__PURE__*/createContext({
  playbackRate: 1,
  setPlaybackRate: () => undefined
});
export const MediaPlaybackRateProvider = ({
  children,
  mediaRef
}) => {
  const [playbackRate, setPlaybackRate] = useState(1);
  const handleSetPlaybackRate = useCallback(nextValue => {
    setPlaybackRate(nextValue);
    if (mediaRef.current) {
      mediaRef.current.playbackRate = nextValue;
    }
  }, [mediaRef]);
  const value = useMemo(() => ({
    setPlaybackRate: handleSetPlaybackRate,
    playbackRate
  }), [handleSetPlaybackRate, playbackRate]);
  return /*#__PURE__*/_jsx(MediaPlaybackRateContext.Provider, {
    value: value,
    children: children
  });
};